export default __webpack_public_path__ + "static/media/BSP_Logo.3cb8625e.png";